<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Reviews

      <v-spacer />
      <v-select
        v-model="filterId"
        outlined
        hide-details
        :items="filterItems"
        label="Filter by status"
        dense
        class="mr-2"
        item-value="id"
        item-text="name"
      />
      <v-text-field
        v-model="search"
        dense
        outlined
        label="Search by keyword"
        clearable
        hide-details
      />
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :items-per-page="100"
        disable-pagination
        class="row-pointer"
        sort-by="date"
        :search="search"
        :sort-desc="true"
        mobile-breakpoint="0"
        @click:row="rowClick"
      >
        <template #[`item.orderId`]="{ item }">
          <router-link :to="`/orders/${item.orderId}`">
            {{ item.orderId }}
          </router-link>
        </template>
        <template #[`item.statusId`]="{ item }">
          {{ review_status_name(item.statusId) }}
        </template>
        <template #[`item.nameAndCompany`]="{ item }">
          <router-link :to="`/users/${item.userId}`">
            {{ item.nameAndCompany }}
          </router-link>
        </template>
        <template #[`item.date`]="{ item }">
          {{ item.date | longDate }}
        </template>
        <template #[`item.actions`]>
          <v-icon>more_vert</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <EditReview />
  </v-card>
</template>

<script>
import EditReview from '@/components/reviews/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'ReviewList',

  components: { EditReview },

  data: () => {
    return {
      search: '',
      filterId: 1,
      headers: [
        { text: 'Order Id', value: 'orderId' },
        { text: 'Design Request Id', value: 'designRequestId' },
        { text: 'Name', value: 'nameAndCompany' },
        { text: 'Status', value: 'statusId' },
        { text: 'Rating', value: 'stars' },
        { text: 'Comment', value: 'comment' },
        { text: 'Date', value: 'date' },
        { text: '', value: 'actions' }
      ],
      loading: false
    };
  },

  computed: {
    filterItems() {
      let items = [{ id: 0, name: 'All' }];
      items = items.concat(this.review_statuses);
      return items;
    },
    items() {
      let list = this.reviews;
      if (this.filterId > 0) {
        list = list.filter((x) => x.statusId === this.filterId);
      }
      return list;
    },
    ...mapGetters({
      reviews: 'reviews/list',
      review_status_name: 'lookup/review_status_name',
      review_statuses: 'lookup/review_statuses'
    })
  },

  mounted() {
    this.loading = true;
    this.$store.dispatch('reviews/load').finally(() => {
      this.loading = false;
    });
  },

  methods: {
    rowClick(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.REVIEW_EDIT_SHOW, {
        id: item.orderId
      });
    }
  }
};
</script>
